import { Environment } from 'src/types';

export const environment: Environment = {
  production: true,
  pocketbaseUrl: 'https://lmkwitg-bda.srv.mwn.de:8443',
  backendUrl: 'https://lmkwitg-bda.srv.mwn.de'
};
